<template>
<div class="chapter">
<div class="inner_page">
<p class="p_toc_heading" id="tableofcontents">Table of Contents</p>
<p class="p_toc_entry_"><a href="#/OPS/section0002#auto_bookmark_toc_1">Blurb</a></p>
<p class="p_toc_entry_"><a href="#/OPS/section0003#auto_bookmark_toc_1">Dedication</a></p>
<p class="p_toc_entry_"><a href="#/OPS/section0004#auto_bookmark_toc_1">Now</a></p>
<p class="p_toc_entry_"><a href="#/OPS/section0005#auto_bookmark_toc_1">Then</a></p>
<p class="p_toc_entry_"><a href="#/OPS/section0006#auto_bookmark_toc_1">Daddies</a></p>
<p class="p_toc_entry_"><a href="#/OPS/section0007#auto_bookmark_toc_1">Baby Steps from Home</a></p>
<p class="p_toc_entry_"><span href="#/OPS/section0008#auto_bookmark_toc_1" title="Link target outside of Sample">Wingman</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0009#auto_bookmark_toc_1" title="Link target outside of Sample">When Your Feet Touch the Stars</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0010#auto_bookmark_toc_1" title="Link target outside of Sample">A Dark Alley</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0011#auto_bookmark_toc_1" title="Link target outside of Sample">Under the Yellow Moon</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0012#auto_bookmark_toc_1" title="Link target outside of Sample">Kept in Cages</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0013#auto_bookmark_toc_1" title="Link target outside of Sample">Long Beginnings</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0014#auto_bookmark_toc_1" title="Link target outside of Sample">Making It Through</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0015#auto_bookmark_toc_1" title="Link target outside of Sample">Songs from Outer Space</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0016#auto_bookmark_toc_1" title="Link target outside of Sample">May to November</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0017#auto_bookmark_toc_1" title="Link target outside of Sample">Dangerous Hobbies</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0018#auto_bookmark_toc_1" title="Link target outside of Sample">Footsteps in the Sand</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0019#auto_bookmark_toc_1" title="Link target outside of Sample">The View from Mars</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0020#auto_bookmark_toc_1" title="Link target outside of Sample">Dancing Alone</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0021#auto_bookmark_toc_1" title="Link target outside of Sample">Frayed and Broken</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0022#auto_bookmark_toc_1" title="Link target outside of Sample">Broken Hearts and Broken Strings</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0023#auto_bookmark_toc_1" title="Link target outside of Sample">When Your Head is in the Stars, You’re Everywhere</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0024#auto_bookmark_toc_1" title="Link target outside of Sample">Reckoning</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0025#auto_bookmark_toc_1" title="Link target outside of Sample">Giving Thanks</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0026#auto_bookmark_toc_1" title="Link target outside of Sample">Amy’s Dark Contemporary Romance</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0027#auto_bookmark_toc_2" title="Link target outside of Sample">Readers love Amy Lane</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0028#auto_bookmark_toc_1" title="Link target outside of Sample">About the Author</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0029#auto_bookmark_toc_1" title="Link target outside of Sample">By Amy Lane</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0030" title="Link target outside of Sample">Visit Dreamspinner Press</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0031#auto_bookmark_toc_1" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?4638d904